<form [formGroup]="otherForm">
  @for (field of objectKeys(fieldList); track field) {
    <ng-container dynamicField [field]="fieldList[field]" [group]="otherForm">
    </ng-container>
  }
</form>
